<template>
  <resource
    resource="automaticMessageRule"
    resourceName="Automatische Nachrichten"
    :attributes="[
      {
        name: 'sender',
        label: 'Absender',
        type: 'FakeSelector'
      },
      {
        name: 'send_to_gender',
        label: 'Sende an',
        type: 'SexSelector',
        multiSelect: true
      },
      {
        name: 'message',
        label: 'Nachricht(en)',
        type: 'MessagePool'
      },
      {
        name: 'delay',
        label: 'Verzögerung',
        type: 'DateRangeSliderSelector',
        max: 30,
        min: 0
      },
      {
        name: 'send_to_users_with_dialogues',
        label: 'An Nutzer mit aktiven Dialogen schicken?',
        type: 'CheckboxSelector'
      }
    ]"
  >
    <div slot="title">
      <h4>Regel für automatische Nachrichten erstellen</h4>
      <div class="card">
        <div class="card-body">
          <i class="fas fa-question-circle text-info"></i>
          Hier können automatische Nachrichten angelegt werden. Es ist das
          entsprechende Fake auszuwählen und die Nachricht oder mehre
          Nachrichten. Auch können unterschiedliche Nachrichtentypen verwendet
          werden. Als Hilfe können sog. Platzhalter verwendet werden, die im
          Text etwas dynamik reinbringen. Das sind beispielsweise der Name des
          Mitglieds, das Alter des Fakes usw.
          <br />
          Unten kann angegeben werden, wann frühstens diese automatische
          Nachricht gesendet wird. Gezählt wird der Zeitpunkt, an dem das
          Mitglied sich vollständig im System verifiziert hat
          (<code>DOI</code>). Zusätzlich kann eine Verzögerung definiert werden.
          Innerhalb dieses Bereiches wird per Zufall ein Zeitpunkt festgelegt,
          wann die automatische Nachricht versendet wird.
          <br />
          Sollte innerhab dieser Zeitspanne das Fake und das Mitglied bereits
          einen aktiven Dialog haben, wird die automatische Nachricht
          <strong>nicht</strong> versendet. Mit aktivieren der Checkbox: "An
          Nutzer mit aktivem Dialogen schicken?" wird diese Regel umgangen und
          dennoch verschickt.
        </div>
      </div>
    </div>
  </resource>
</template>

<script lang="babel">
export default {}
</script>
